/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Вложение СПД клиента для сохранения
 */
export interface AttachmentUnit {
  /**
   * Айди файла
   * @format uuid
   */
  id?: string;

  /** Категория файла */
  category?: string;
}

/**
 * СПД клиента для редактирования V2
 */
export interface UpdateCertConfDocsV3Request {
  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка */
  clientBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** Идентификатор договора */
  contractId?: string;

  /** УНК */
  trPassportNumber?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Идентификатор ответственного */
  responsiblePersonId?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Идентификатор корректируемого документа */
  correctingDocId?: string;

  /** Номер корректировки */
  corrNum?: string;

  /**
   * Дата корректировки
   * @format date
   */
  corrDate?: string;

  /** Документы СПД */
  confDocuments?: UpdateConfDocUnitClient[];

  /** Список загруженных вложений */
  attachments?: AttachmentUnit[];

  /** Идентификаторы удаленных вложений */
  removedAttachmentIds?: string[];
}

/**
 * Документ СПД клиента для редактирования
 */
export interface UpdateConfDocUnitClient {
  /** Тип декларации/стат.формы: DECLARATION/STATISTICAL_FORM */
  documentType?: string;

  /**
   * Порядковый номер документа
   * @format int32
   */
  docNum?: number;

  /** Идентификатор подтверждающего документа (декларации/статформы и т.д.) */
  declarationId?: string;

  /** Признак поставки */
  signSupply?: string;

  /** Признак отсутствия номера подтверждающего документа */
  isWithoutNumber?: boolean;

  /**
   * Дата подтверждающего документа
   * @format date
   */
  date?: string;

  /** Номер подтверждающего документа */
  docConfirmNumber?: string;

  /** Код вида подтверждающего документа */
  codeTypeDoc?: string;

  /** Буквенный код валюты документа */
  docCurrCode?: string;

  /** Цифровой код валюты документа */
  docCurrCodeIso?: string;

  /** Описание валюты документа */
  docCurrDesc?: string;

  /** Сумма документа */
  sumDoc?: number;

  /** Сумма отсрочки (документа) */
  sumDoc2?: number;

  /** Код валюты договора */
  contrCurrCode?: string;

  /** Буквенный код валюты договора */
  contrCurrCodeIso?: string;

  /** Описание валюты договора */
  contrCurrDesc?: string;

  /** Сумма в валюте договора */
  sumContr?: number;

  /** Сумма отсрочки (договора) */
  sumContr2?: number;

  /**
   * Ожидаемый срок репатриации иностранной валюты и (или) валюты Российской Федерации (срок исполнения обязательств)
   * @format date
   */
  expectedDate?: string;

  /** Страна грузоотправителя */
  country?: string;

  /** Примечание */
  comment?: string;

  /** Зачисление на счет нерезидента КНР */
  docApproveForNotResidentKNR?: boolean;

  /** В соответствии с подпунктом 8.1.4 пункта 8.1 Инструкции 181-И представлены справка о подтверждающих документах и документы и (или) информация по статистической форме, подтверждающие необходимость исключения из расчетов показателей разделов IV и V информации о статистической форме, которая включена в подраздел III.I */
  removeStaticFormInfo?: boolean;

  /** В соответствии с подпунктом 8.1.4 пункта 8.1 Инструкции 181-И представлены справка о подтверждающих документах и документы и (или) информация по статистической форме, подтверждающие безвозмездную поставку */
  freeDelivery?: boolean;
}

/**
 * Список предупреждений для вложений
 */
export interface AttachmentWarningDetail {
  /** Сообщение */
  message?: string;
}

/**
 * Список предупреждений для общей части документа
 */
export interface CertConfDocWarningDetail {
  /** Сообщение */
  message?: string;

  /** Список полей */
  fields?: string[];

  /** Валидное значение */
  validValue?: number[];
}

/**
 * Результат валидации документа
 */
export interface ConfDocErrorDetail {
  /** Сообщение об ошибке */
  message?: string;

  /** Список полей с ошибкой */
  fields?: string[];

  /**
   * Порядковый номер документа
   * @format int32
   */
  docNumber?: number;
}

/**
 * Список предупреждений для спд
 */
export interface ConfDocWarningDetail {
  /** Сообщение */
  message?: string;

  /** Список полей */
  fields?: string[];

  /**
   * Порядковый номер документа
   * @format int32
   */
  docNumber?: number;
}

/**
 * Ошибки
 */
export interface ValidationErrors {
  /** Ошибки в документе спд */
  confDocDetails?: ConfDocErrorDetail[];
}

/**
 * Валидация СПД
 */
export interface ValidationResponse {
  /** Ошибки */
  errors?: ValidationErrors;

  /** Предупреждения */
  warnings?: ValidationWarnings;
}

/**
 * Предупреждения
 */
export interface ValidationWarnings {
  /** Список предупреждений для спд */
  confDocDetails?: ConfDocWarningDetail[];

  /** Список предупреждений для вложений */
  attachmentDetails?: AttachmentWarningDetail[];

  /** Список предупреждений для общей части документа */
  certConfDocDetails?: CertConfDocWarningDetail[];
}

/**
 * Ответ на запрос редактирования СПД клиента
 */
export interface UpdateCertConfDocsResponse {
  /**
   * Идентификатор СПД
   * @format uuid
   */
  spdId?: string;
}

/**
 * СПД клиента для редактирования V2
 */
export interface UpdateCertConfDocsV2Request {
  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка */
  clientBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** Идентификатор договора */
  contractId?: string;

  /** УНК */
  trPassportNumber?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Идентификатор ответственного */
  responsiblePersonId?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Идентификатор корректируемого документа */
  correctingDocId?: string;

  /** Номер корректировки */
  corrNum?: string;

  /**
   * Дата корректировки
   * @format date
   */
  corrDate?: string;

  /** Документы СПД */
  confDocuments?: UpdateConfDocUnitClient[];

  /** Список ID загруженных вложений */
  attachmentIds?: string[];

  /** Идентификаторы удаленных вложений */
  removedAttachmentIds?: string[];
}

export interface ErrorMessage {
  /** @format uuid */
  id?: string;
  message?: string;
}

/**
 * Вложение СПД клиента для редактирования
 */
export interface UpdateAttachmentUnitClient {
  /** Имя файла */
  fileName?: string;

  /** Содержимое файла */
  encodedString?: string;
}

/**
 * СПД клиента для редактирования
 */
export interface UpdateCertConfDocsRequest {
  /**
   * Идентификатор СПД
   * @format uuid
   */
  id: string;

  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка */
  clientBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** Идентификатор договора */
  contractId?: string;

  /** УНК */
  trPassportNumber?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Идентификатор ответственного */
  responsiblePersonId?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Идентификатор корректируемого документа */
  correctingDocId?: string;

  /** Номер корректировки */
  corrNum?: string;

  /**
   * Дата корректировки
   * @format date
   */
  corrDate?: string;

  /** Идентификаторы удаленных вложений */
  removedAttachments?: string[];

  /** Документы СПД */
  confDocuments?: UpdateConfDocUnitClient[];

  /** Вложения СПД */
  spdConfAttachments?: UpdateAttachmentUnitClient[];
}

/**
 * СПД клиента для сохранения V2
 */
export interface SaveCertConfDocsV3Request {
  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка */
  clientBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** Идентификатор договора */
  contractId?: string;

  /** УНК */
  trPassportNumber?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Идентификатор ответственного */
  responsiblePersonId?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Идентификатор корректируемого документа */
  correctingDocId?: string;

  /** Номер корректировки */
  corrNum?: string;

  /**
   * Дата корректировки
   * @format date
   */
  corrDate?: string;

  /** Документы СПД */
  confDocuments?: SaveConfDocUnitClient[];

  /** Список загруженных вложений */
  attachments?: AttachmentUnit[];
}

/**
 * Документ СПД клиента для сохранения
 */
export interface SaveConfDocUnitClient {
  /** Тип декларации/стат.формы: DECLARATION/STATISTICAL_FORM */
  documentType?: string;

  /**
   * Порядковый номер документа
   * @format int32
   */
  docNum?: number;

  /** Идентификатор подтверждающего документа (декларации/статформы и т.д.) */
  declarationId?: string;

  /** Признак поставки */
  signSupply?: string;

  /** Признак отсутствия номера подтверждающего документа */
  isWithoutNumber?: boolean;

  /**
   * Дата подтверждающего документа
   * @format date
   */
  date?: string;

  /** Номер подтверждающего документа */
  docConfirmNumber?: string;

  /** Код вида подтверждающего документа */
  codeTypeDoc?: string;

  /** Буквенный код валюты документа */
  docCurrCode?: string;

  /** Цифровой код валюты документа */
  docCurrCodeIso?: string;

  /** Описание валюты документа */
  docCurrDesc?: string;

  /** Сумма документа */
  sumDoc?: number;

  /** Сумма отсрочки (документа) */
  sumDoc2?: number;

  /** Код валюты договора */
  contrCurrCode?: string;

  /** Буквенный код валюты договора */
  contrCurrCodeIso?: string;

  /** Описание валюты договора */
  contrCurrDesc?: string;

  /** Сумма в валюте договора */
  sumContr?: number;

  /** Сумма отсрочки (договора) */
  sumContr2?: number;

  /**
   * Ожидаемый срок репатриации иностранной валюты и (или) валюты Российской Федерации (срок исполнения обязательств)
   * @format date
   */
  expectedDate?: string;

  /** Страна грузоотправителя */
  country?: string;

  /** Примечание */
  comment?: string;

  /** Зачисление на счет нерезидента КНР */
  docApproveForNotResidentKNR?: boolean;

  /** В соответствии с подпунктом 8.1.4 пункта 8.1 Инструкции 181-И представлены справка о подтверждающих документах и документы и (или) информация по статистической форме, подтверждающие необходимость исключения из расчетов показателей разделов IV и V информации о статистической форме, которая включена в подраздел III.I */
  removeStaticFormInfo?: boolean;

  /** В соответствии с подпунктом 8.1.4 пункта 8.1 Инструкции 181-И представлены справка о подтверждающих документах и документы и (или) информация по статистической форме, подтверждающие безвозмездную поставку */
  freeDelivery?: boolean;
}

/**
 * Ответ на запрос сохранения СПД клиента
 */
export interface SaveCertConfDocsResponse {
  /**
   * Идентификатор СПД
   * @format uuid
   */
  spdId?: string;
}

/**
 * СПД клиента для сохранения V2
 */
export interface SaveCertConfDocsV2Request {
  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка */
  clientBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** Идентификатор договора */
  contractId?: string;

  /** УНК */
  trPassportNumber?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Идентификатор ответственного */
  responsiblePersonId?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Идентификатор корректируемого документа */
  correctingDocId?: string;

  /** Номер корректировки */
  corrNum?: string;

  /**
   * Дата корректировки
   * @format date
   */
  corrDate?: string;

  /** Документы СПД */
  confDocuments?: SaveConfDocUnitClient[];

  /** Список ID загруженных вложений */
  attachmentIds?: string[];
}

export interface AttachmentUploadClientResponse {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  clientId?: string;
  fileName?: string;
  ready?: boolean;
  errorCode?: string;
  errorDescription?: string;
  category?: string;

  /** @format int64 */
  size?: number;
}

/**
 * Вложение СПД клиента для сохранения
 */
export interface SaveAttachmentUnitClient {
  /** Имя файла */
  fileName?: string;

  /** Содержимое файла в Base64 */
  encodedString?: string;
}

/**
 * СПД клиента для сохранения
 */
export interface SaveCertConfDocsRequest {
  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка */
  clientBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** Идентификатор договора */
  contractId?: string;

  /** УНК */
  trPassportNumber?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Идентификатор ответственного */
  responsiblePersonId?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Идентификатор корректируемого документа */
  correctingDocId?: string;

  /** Номер корректировки */
  corrNum?: string;

  /**
   * Дата корректировки
   * @format date
   */
  corrDate?: string;

  /** Документы СПД */
  confDocuments?: SaveConfDocUnitClient[];

  /** Вложения СПД */
  spdConfAttachments?: SaveAttachmentUnitClient[];
}

/**
 * Список статических форм для сотрудника
 */
export interface GetStatFormListResponse {
  /** Пагинированный список статических форм */
  statFormEntries?: PageStatFormEntry;

  /**
   * Размер возвращаемого списка статических форм
   * @format int32
   */
  size?: number;

  /** Есть ли ещё записи, кроме предоставленных */
  hasMore?: boolean;
}

/**
 * Пагинированный список статических форм
 */
export interface PageStatFormEntry {
  /** @format int64 */
  totalElements?: number;

  /** @format int32 */
  totalPages?: number;

  /** @format int32 */
  size?: number;
  content?: StatFormEntry[];

  /** @format int32 */
  number?: number;
  sort?: SortObject;

  /** @format int32 */
  numberOfElements?: number;
  last?: boolean;
  pageable?: PageableObject;
  first?: boolean;
  empty?: boolean;
}

export interface PageableObject {
  /** @format int64 */
  offset?: number;
  sort?: SortObject;
  paged?: boolean;
  unpaged?: boolean;

  /** @format int32 */
  pageNumber?: number;

  /** @format int32 */
  pageSize?: number;
}

export interface SortObject {
  empty?: boolean;
  unsorted?: boolean;
  sorted?: boolean;
}

/**
 * Документы, подтверждающие совершение внешнеэкономической сделки
 */
export interface StatConfirmationDocumentRs {
  /** Название документа, подтверждающего совершение внешнеэкономической сделки */
  documentName?: string;

  /** Номер документа, подтверждающего совершение внешнеэкономической сделки */
  documentNumber?: string;

  /** Дата документа, подтверждающего совершение внешнеэкономической сделки */
  documentDate?: string;
}

/**
 * StatFormEntry
 */
export interface StatFormEntry {
  /**
   * Идентификатор статической формы
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор клиента
   * @format uuid
   */
  clientId?: string;

  /** Порядковый номер электронного сообщения */
  messageNumber?: string;

  /**
   * Дата/время формирования сообщения
   * @format date-time
   */
  created?: string;

  /** Получатель ЭССФ регистрационный номер банка */
  essfBankRegNumber?: string;

  /** Получатель ЭССФ номер филиала */
  essfBankFilNumber?: string;

  /** Наименование файла электронного сообщения */
  essfFileName?: string;

  /** Регистрационный номер статистической формы учёта перемещения товаров */
  regnum?: string;

  /** Номер аннулируемой статистической формы */
  regnumCancel?: string;

  /** Номер документа, подтверждающего соблюдение требований в области валютного контроля */
  currDocumentNumber?: string;

  /** Направление перемещения товаров */
  productMovements?: string;

  /** Наименование клиента */
  clientName?: string;

  /** Основной государственный регистрационный номер лица */
  clientOgrn?: string;

  /** Инн клиента */
  clientInn?: string;

  /** Кпп клиента */
  clientKpp?: string;

  /** Наименование лица, ответственного за финансовое урегулирование */
  financeManager?: string;

  /** Буквенный код валюты цены договора */
  currCode?: string;

  /** Общая стоимость всех  товаров */
  amount?: number;

  /** Буквенный код страны назначения товаров */
  destinationCountryCode?: string;

  /** Буквенный код страны отправления товаров */
  departureCountryCode?: string;

  /**
   * Месяц и год отгрузки (получения) товара
   * @format date
   */
  documentMonthYear?: string;

  /**
   * Дата аннулирования статистической формы
   * @format date
   */
  documentDateCancel?: string;

  /**
   * Дата и время корректировки Статформы
   * @format date-time
   */
  sfDateTimeUpdated?: string;

  /**
   * Идентификатор оператора
   * @format uuid
   */
  operatorId?: string;

  /** Телефон оператора */
  operatorPhone?: string;

  /** ФИО оператора */
  operatorName?: string;

  /** Статус */
  state?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Сообшение о валютном контроле */
  curControlMessage?: string;

  /** Идентификатор СПД в монолите */
  spdId?: string;

  /** Код вида подтверждающего документа */
  docConfirmCode?: string;

  /** Описание код вида подтверждающего документа */
  docConfirmCodeDesc?: string;

  /** УНК */
  documentNumber?: string;

  /** Тип документа. Дефолтное значение - STATISTICAL_FORM */
  documentType?: string;

  /** Документы, подтверждающие совершение внешнеэкономической сделки */
  confirmationDocuments?: StatConfirmationDocumentRs[];
  sfdelted?: boolean;
}

/**
 * Права пользователя
 */
export interface GetPermissionUnit {
  /** Название возможности */
  name?: string;

  /** Описание возможности */
  desc?: string;

  /** Признак доступности возможности */
  isAvailable?: boolean;
}

/**
 * Детальная информация статической формы
 */
export interface GetStatFormByIdResponse {
  /**
   * Идентификатор статической формы
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор клиента
   * @format uuid
   */
  clientId?: string;

  /** Порядковый номер электронного сообщения */
  messageNumber?: string;

  /**
   * Дата/время формирования сообщения
   * @format date-time
   */
  created?: string;

  /** Получатель ЭССФ регистрационный номер банка */
  essfBankRegNumber?: string;

  /** Получатель ЭССФ номер филиала */
  essfBankFilNumber?: string;

  /** Наименование файла электронного сообщения */
  essfFileName?: string;

  /** Регистрационный номер статистической формы учёта перемещения товаров */
  regnum?: string;

  /** Номер аннулируемой статистической формы */
  regnumCancel?: string;

  /** Номер документа, подтверждающего соблюдение требований в области валютного контроля */
  currDocumentNumber?: string;

  /** Направление перемещения товаров */
  productMovements?: string;

  /** Наименование клиента */
  clientName?: string;

  /** Основной государственный регистрационный номер лица */
  clientOgrn?: string;

  /** Инн клиента */
  clientInn?: string;

  /** Кпп клиента */
  clientKpp?: string;

  /** Наименование лица, ответственного за финансовое урегулирование */
  financeManager?: string;

  /** Буквенный код валюты цены договора */
  currCode?: string;

  /** Общая стоимость всех  товаров */
  amount?: number;

  /** Буквенный код страны назначения товаров */
  destinationCountryCode?: string;

  /** Буквенный код страны отправления товаров */
  departureCountryCode?: string;

  /**
   * Месяц и год отгрузки (получения) товара
   * @format date
   */
  documentMonthYear?: string;

  /**
   * Дата аннулирования статистической формы
   * @format date
   */
  documentDateCancel?: string;

  /**
   * Дата и время корректировки Статформы
   * @format date-time
   */
  sfDateTimeUpdated?: string;

  /**
   * Идентификатор оператора
   * @format uuid
   */
  operatorId?: string;

  /** Телефон оператора */
  operatorPhone?: string;

  /** ФИО оператора */
  operatorName?: string;

  /** Статус */
  state?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Сообшение о валютном контроле */
  curControlMessage?: string;

  /** Идентификатор СПД в монолите */
  spdId?: string;

  /** Код вида подтверждающего документа */
  docConfirmCode?: string;

  /** Описание код вида подтверждающего документа */
  docConfirmCodeDesc?: string;

  /** УНК */
  documentNumber?: string;

  /** Возможности сотрудника */
  permissions?: GetPermissionUnit[];

  /** Документы, подтверждающие совершение внешнеэкономической сделки */
  confirmationDocuments?: StatConfirmationDocumentRs[];
  sfdelted?: boolean;
}

/**
 * Документ СПД списка для клиента
 */
export interface ConfDocClientEntry {
  /**
   * Идентификатор документа СПД
   * @format uuid
   */
  confDocId?: string;

  /** Признак отсутствия номера подтверждающего документа */
  isWithoutNumber?: boolean;

  /**
   * Дата подтверждающего документа
   * @format date
   */
  date?: string;

  /** Номер подтверждающего документа */
  docConfirmNumber?: string;

  /** Сумма документа */
  sumDoc?: number;

  /** Цифровой код валюты документа */
  docCurrCodeIso?: string;

  /** Буквенный код валюты документа */
  docCurrCode?: string;
}

/**
 * СПД пагинированного списка для клиента
 */
export interface GetCertConfDocsEntryClient {
  /**
   * Идентификатор СПД
   * @format uuid
   */
  spdId?: string;

  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /**
   * Дата изменения документа
   * @format date-time
   */
  stateChangeDate?: string;

  /** Статус */
  state?: string;

  /**
   * Дата обработки
   * @format date
   */
  bankInfoProcessDate?: string;

  /** Инн клиента */
  clientInn?: string;

  /** Наименование клиента */
  clientName?: string;

  /** Филиал */
  branchName?: string;

  /** УНК */
  trPassportNumber?: string;

  /** Досыл */
  isFileSending?: boolean;

  /** Система, в которой создан СПД (MS, DBOLE, CSDBO) */
  extSystem?: string;

  /** Документы СПД */
  confDocuments?: ConfDocClientEntry[];

  /** Возможности клиента */
  permissions?: GetEntryClientPermissionUnit[];

  /**
   * Идентификатор отзыва
   * @format uuid
   */
  revokeId?: string;

  /**
   * Идентификатор контракта
   * @format uuid
   */
  contractId?: string;
}

/**
 * Список СПД для клиента
 */
export interface GetCertConfDocsListClientResponse {
  /** Пагинированный список СПД */
  certConfDocsEntries?: PageGetCertConfDocsEntryClient;

  /**
   * Размер возвращаемого списка СПД
   * @format int32
   */
  size?: number;
}

/**
 * Возможности клиента
 */
export interface GetEntryClientPermissionUnit {
  /** Название возможности */
  name?: string;

  /** Описание возможности */
  desc?: string;

  /** Признак доступности возможности */
  isAvailable?: boolean;
}

/**
 * Пагинированный список СПД
 */
export interface PageGetCertConfDocsEntryClient {
  /** @format int64 */
  totalElements?: number;

  /** @format int32 */
  totalPages?: number;

  /** @format int32 */
  size?: number;
  content?: GetCertConfDocsEntryClient[];

  /** @format int32 */
  number?: number;
  sort?: SortObject;

  /** @format int32 */
  numberOfElements?: number;
  last?: boolean;
  pageable?: PageableObject;
  first?: boolean;
  empty?: boolean;
}

/**
 * Вложение СПД для клиента
 */
export interface GetAttachmentUnitClient {
  /**
   * Идентификатор вложения
   * @format uuid
   */
  id?: string;

  /** Имя файла */
  fileName?: string;

  /**
   * Размер файла
   * @format int64
   */
  size?: number;

  /** Готовность загрузки файла в хранилище */
  ready?: boolean;

  /** Ошибка загрузки файла в хранилище */
  errorCode?: string;

  /** Описание ошибки загрузки файла в хранилище */
  errorDescription?: string;

  /** Категория файла */
  category?: string;

  /** Идентификатор файла в внешней системе */
  extId?: string;
}

/**
 * СПД для клиента
 */
export interface GetCertConfDocsByIdClientResponse {
  /**
   * Идентификатор СПД
   * @format uuid
   */
  spdId?: string;

  /** Документы СПД */
  confDocuments?: GetConfDocUnitClient[];

  /** Вложения СПД */
  attachments?: GetAttachmentUnitClient[];

  /** Возможности клиента */
  permissions?: GetClientPermissionUnit[];

  /** Корректирующие СПД */
  correctiveCertConfDocs?: GetCorrectiveCertConfDocUnitClient[];

  /** Идентификатор СПД из внешней системы */
  extId?: string;

  /** Система, в которой создан СПД (MS, DBOLE, CSDBO) */
  extSystem?: string;

  /** Статус */
  state?: string;

  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка */
  clientBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** КПП клиента */
  clientKpp?: string;

  /**
   * Код договора
   * @format uuid
   */
  contractId?: string;

  /** УНК */
  trPassportNumber?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Причина отказа из справочника */
  bankInfoRejectReason?: string;

  /** Причина отказа (комментарий) */
  bankInfoComment?: string;

  /** ФИО работника Банка, выполнившего обработку */
  bankInfoEmployeeName?: string;

  /**
   * Дата обработки
   * @format date
   */
  bankInfoProcessDate?: string;

  /** ФИО подписанта 1 */
  clientFioFirst?: string;

  /**
   * Дата подписи 1
   * @format date-time
   */
  signatureDateFirst?: string;

  /** ФИО подписанта 2 */
  clientFioSecond?: string;

  /**
   * Дата подписи 2
   * @format date-time
   */
  signatureDateSecond?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Идентификатор корректируемого документа */
  correctingDocId?: string;

  /**
   * Номер корректируемого документа
   * @format int64
   */
  corrNum?: number;

  /**
   * Дата корректируемого документа
   * @format date
   */
  corrDate?: string;

  /**
   * Идентификатор отзыва
   * @format uuid
   */
  revokeId?: string;
}

/**
 * Возможности клиента
 */
export interface GetClientPermissionUnit {
  /** Название возможности */
  name?: string;

  /** Описание возможности */
  desc?: string;

  /** Признак доступности возможности */
  isAvailable?: boolean;
}

/**
 * Документ СПД
 */
export interface GetConfDocUnitClient {
  /**
   * Идентификатор документа СПД
   * @format uuid
   */
  id?: string;

  /** Тип декларации/стат.формы: DECLARATION/STATISTICAL_FORM */
  documentType?: string;

  /** Признак поставки */
  signSupply?: string;

  /** Описание признака поставки */
  signSupplyDesc?: string;

  /** Идентификатор подтверждающего документа (декларации/статформы и т.д.) */
  declarationId?: string;

  /**
   * Дата подтверждающего документа
   * @format date
   */
  date?: string;

  /** Номер подтверждающего документа */
  docConfirmNumber?: string;

  /** Признак отсутствия номера подтверждающего документа */
  isWithoutNumber?: boolean;

  /** Код вида подтверждающего документа */
  codeTypeDoc?: string;

  /** Описание кода вида подтверждающего документа */
  codeTypeDocDesc?: string;

  /** Описание валюты по документу */
  docCurrDesc?: string;

  /** Буквенный код валюты документа */
  docCurrCode?: string;

  /** Цифровой код валюты документа */
  docCurrCodeIso?: string;

  /** Сумма документа */
  sumDoc?: number;

  /** Сумма отсрочки (документа) */
  sumDoc2?: number;

  /** Описание валюты по договору */
  contrCurrDesc?: string;

  /** Буквенный код валюты договора */
  contrCurrCode?: string;

  /** Цифровой код валюты договора */
  contrCurrCodeIso?: string;

  /** Сумма в валюте договора */
  sumContr?: number;

  /** Сумма отсрочки (договора) */
  sumContr2?: number;

  /**
   * Ожидаемый срок репатриации иностранной валюты и (или) валюты Российской Федерации (срок исполнения обязательств)
   * @format date
   */
  expectedDate?: string;

  /** Страна грузоотправителя */
  country?: string;

  /** Примечание */
  comment?: string;

  /** Зачисление на счет нерезидента КНР */
  docApproveForNotResidentKNR?: boolean;

  /**
   * Номер документа
   * @format int32
   */
  docNum?: number;

  /** В соответствии с подпунктом 8.1.4 пункта 8.1 Инструкции 181-И представлены справка о подтверждающих документах и документы и (или) информация по статистической форме, подтверждающие необходимость исключения из расчетов показателей разделов IV и V информации о статистической форме, которая включена в подраздел III.I */
  removeStaticFormInfo?: boolean;

  /** В соответствии с подпунктом 8.1.4 пункта 8.1 Инструкции 181-И представлены справка о подтверждающих документах и документы и (или) информация по статистической форме, подтверждающие безвозмездную поставку */
  freeDelivery?: boolean;
}

/**
 * Корректирующие СПД
 */
export interface GetCorrectiveCertConfDocUnitClient {
  /** Идентификатор корректирующей СПД */
  spdId?: string;

  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Статус */
  state?: string;
}

/**
 * Первоначальные данные
 */
export interface GetPrimaryDataResponse {
  /**
   * Номер документа
   * @format int64
   */
  documentNumber?: number;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование резидента */
  clientName?: string;

  /** Наименование банка */
  clientBankName?: string;
}

/**
 * Признак поставки
 */
export interface SignSupplyResponse {
  /**
   * Код признака поставки
   * @format int32
   */
  code?: number;

  /** Описание признака поставки */
  desc?: string;
}

/**
 * Список прав пользователя
 */
export interface PermissionResponse {
  /** Тип документа */
  entityStrId?: string;
  permissions?: GetPermissionUnit[];
}

/**
 * DeclarationUnit
 */
export interface DeclarationUnit {
  /**
   * Идентификатор декларации на товары
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор СПД МС
   * @format uuid
   */
  msSpdId?: string;

  /** Статус СПД МС */
  msSpdState?: string;

  /**
   * Идентификатор СПД в монолите
   * @format int64
   */
  spdId?: number;

  /**
   * Идентификатор клиента
   * @format uuid
   */
  clientId?: string;

  /** Номер ДТ */
  dtNumber?: string;

  /**
   * Дата ДТ
   * @format date-time
   */
  dtDate?: string;

  /** Сумма ДТ */
  dtAmount?: number;

  /** Цифровой код валюты ДТ */
  dtCurrCode?: string;

  /** Уникальный номер контракта (УНК) */
  unk?: string;

  /** Код вида подтверждающего документа */
  docConfirmCode?: string;

  /** Признак поставки */
  signDelivery?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Информация из подраздела раздела 3 */
  info3?: string;

  /**
   * Дата/ время создания записи
   * @format date-time
   */
  dateTimeCreate?: string;

  /**
   * Дата/ время изменения записи
   * @format date-time
   */
  dateTimeModified?: string;

  /** Признак неактуальности: 0 – запись актуальна; 1 – 1 – запись удалена */
  isDeleted?: boolean;

  /** Статус */
  state?: string;

  /** Сообщение о валютном контроле */
  curControlMessage?: string;

  /** Тип документа. Дефолтное значение - DECLARATION */
  documentType?: string;
}

/**
 * Список деклараций
 */
export interface GetAllDeclarationsResponse {
  /** Список деклараций */
  declarations: DeclarationUnit[];

  /**
   * Число деклараций
   * @format int64
   */
  count: number;
}

/**
 * Декларация
 */
export interface GetDeclarationByIdResponse {
  /**
   * Идентификатор декларации на товары
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор СПД МС
   * @format uuid
   */
  msSpdId?: string;

  /**
   * Идентификатор СПД в монолите
   * @format int64
   */
  spdId?: number;

  /**
   * Системный номер клиента комплекса
   * @format uuid
   */
  clientId?: string;

  /** Номер ДТ */
  dtNumber?: string;

  /**
   * Дата ДТ
   * @format date-time
   */
  dtDate?: string;

  /** Сумма ДТ */
  dtAmount?: number;

  /** Цифровой код валюты ДТ */
  dtCurrCode?: string;

  /** Уникальный номер контракта (УНК) */
  unk?: string;

  /** Код вида подтверждающего документа */
  docConfirmCode?: string;

  /** Признак поставки */
  signDelivery?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Информация из подраздела раздела 3 */
  info3?: string;

  /**
   * Дата/ время создания записи
   * @format date-time
   */
  dateTimeCreate?: string;

  /**
   * Дата/ время изменения записи
   * @format date-time
   */
  dateTimeModified?: string;

  /** Признак неактуальности: 0 – запись актуальна; 1 – 1 – запись удалена */
  isDeleted?: boolean;

  /** Статус */
  state?: string;

  /** Сообщение о валютном контроле */
  curControlMessage?: string;
}

/**
 * Валюта
 */
export interface CurrencyResponse {
  /**
   * Идентификатор валюты
   * @format uuid
   */
  id?: string;

  /** Буквенный код валюты */
  code?: string;

  /** Цифровой код валюты */
  codeIso?: string;

  /** Описание валюты */
  desc?: string;
}

/**
 * Страна
 */
export interface CountryResponse {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Код */
  code?: string;

  /** Описание */
  desc?: string;
}

/**
 * ККБ документа
 */
export interface CcbDocument {
  /** ККБ документа */
  fields?: CcbDocument;

  /** Тип документа */
  type?: DocumentType;
}

/**
 * Получение ккб конкретного документа
 */
export interface DocumentCcbResponse {
  /** Документ ККБ */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** ККБ документа */
  document?: CcbDocument;
}

/**
 * Тип документа
 */
export interface DocumentType {
  name?: string;
  desc?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Код вида подтверждающих документов
 */
export interface CodeTypeDocResponse {
  /** Код */
  code?: string;

  /** Описание */
  desc?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title owb-ms-prd-conf-doc
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-conf-doc.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name UpdateCertConfDocsForClientV3
     * @summary Редактирование СПД для клиента. Версия 3
     * @request PUT:/api/conf-doc/v3/external/spd/{id}
     * @secure
     */
    updateCertConfDocsForClientV3: (
      id: string,
      data: UpdateCertConfDocsV3Request,
      query?: { isDraft?: boolean; ignoreWarning?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<UpdateCertConfDocsResponse, ValidationResponse>({
        path: `/api/conf-doc/v3/external/spd/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name UpdateCertConfDocsForClientV2
     * @summary Редактирование СПД для клиента. Версия 2
     * @request PUT:/api/conf-doc/v2/external/spd/{id}
     * @secure
     */
    updateCertConfDocsForClientV2: (
      id: string,
      data: UpdateCertConfDocsV2Request,
      query?: { isDraft?: boolean; ignoreWarning?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<UpdateCertConfDocsResponse, ValidationResponse>({
        path: `/api/conf-doc/v2/external/spd/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о статических формах товара
     * @name UpdateStatus
     * @summary Обновление статуса статической формы
     * @request PUT:/api/conf-doc/v1/external/statform/state/{id}
     * @secure
     */
    updateStatus: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/conf-doc/v1/external/statform/state/${id}`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name GetCertConfDocsForClient
     * @summary Получение списка СПД для клиента
     * @request GET:/api/conf-doc/v1/external/spd
     * @secure
     */
    getCertConfDocsForClient: (
      query?: {
        position?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
        stateList?: string[];
        isDboleDocumentInclude?: boolean;
        trPassportNumber?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetCertConfDocsListClientResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/spd`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name UpdateCertConfDocsForClient
     * @summary Редактирование СПД для клиента
     * @request PUT:/api/conf-doc/v1/external/spd
     * @secure
     */
    updateCertConfDocsForClient: (
      data: UpdateCertConfDocsRequest,
      query?: { isDraft?: boolean; ignoreWarning?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<UpdateCertConfDocsResponse, ValidationResponse>({
        path: `/api/conf-doc/v1/external/spd`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name SaveCertConfDocsForClient
     * @summary Сохранение СПД для клиента
     * @request POST:/api/conf-doc/v1/external/spd
     * @secure
     */
    saveCertConfDocsForClient: (
      data: SaveCertConfDocsRequest,
      query?: { isDraft?: boolean; ignoreWarning?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<SaveCertConfDocsResponse, ValidationResponse>({
        path: `/api/conf-doc/v1/external/spd`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о декларациях товара
     * @name UpdateDeclarationStatusExternal
     * @summary Обновление статуса декларации для клиента
     * @request PUT:/api/conf-doc/v1/external/decl/state/{dtId}
     * @secure
     */
    updateDeclarationStatusExternal: (
      dtId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/conf-doc/v1/external/decl/state/${dtId}`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name SaveCertConfDocsForClientV3
     * @summary Сохранение СПД для клиента. Версия 3
     * @request POST:/api/conf-doc/v3/external/spd
     * @secure
     */
    saveCertConfDocsForClientV3: (
      data: SaveCertConfDocsV3Request,
      query?: { isDraft?: boolean; ignoreWarning?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<SaveCertConfDocsResponse, ValidationResponse>({
        path: `/api/conf-doc/v3/external/spd`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name SaveCertConfDocsForClientV2
     * @summary Сохранение СПД для клиента. Версия 2
     * @request POST:/api/conf-doc/v2/external/spd
     * @secure
     */
    saveCertConfDocsForClientV2: (
      data: SaveCertConfDocsV2Request,
      query?: { isDraft?: boolean; ignoreWarning?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<SaveCertConfDocsResponse, ValidationResponse>({
        path: `/api/conf-doc/v2/external/spd`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Вложения
     * @name UploadMultipartFile
     * @summary Загрузка файла клиентом
     * @request POST:/api/conf-doc/v2/external/spd/attach/upload
     * @secure
     */
    uploadMultipartFile: (
      data: { file: File },
      query?: { category?: string },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentUploadClientResponse, ErrorMessage>({
        path: `/api/conf-doc/v2/external/spd/attach/upload`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о статических формах товара
     * @name GetStatForms
     * @summary Получение списка статических форм для клиента
     * @request GET:/api/conf-doc/v1/external/statform
     * @secure
     */
    getStatForms: (
      query: {
        size: number;
        position: number;
        dtAmount?: number;
        unk?: string;
        dtNumber?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetStatFormListResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/statform`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о статических формах товара
     * @name GetStatForm
     * @summary Получение детальной информации статической формы по id
     * @request GET:/api/conf-doc/v1/external/statform/{id}
     * @secure
     */
    getStatForm: (id: string, params: RequestParams = {}) =>
      this.request<GetStatFormByIdResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/statform/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name GetCertConfDocsByIdForClient
     * @summary Получение детальной формы СПД по id для клиента
     * @request GET:/api/conf-doc/v1/external/spd/{id}
     * @secure
     */
    getCertConfDocsByIdForClient: (id: string, params: RequestParams = {}) =>
      this.request<GetCertConfDocsByIdClientResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/spd/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name PrintForClient
     * @summary Печать для клиента
     * @request GET:/api/conf-doc/v1/external/spd/print
     * @secure
     */
    printForClient: (query: { id: string }, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/conf-doc/v1/external/spd/print`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name GetPrimaryDataForClient
     * @summary Получение первоначальных данных для клиента
     * @request GET:/api/conf-doc/v1/external/spd/primary-data
     * @secure
     */
    getPrimaryDataForClient: (params: RequestParams = {}) =>
      this.request<GetPrimaryDataResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/spd/primary-data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справка о подтверждающих документах
     * @name AttachmentForClient
     * @summary Скачивание Вложения для клиента
     * @request GET:/api/conf-doc/v1/external/spd/attach
     * @secure
     */
    attachmentForClient: (query: { id: string }, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/conf-doc/v1/external/spd/attach`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetAllSignSupplyList
     * @summary Получение списка признаков поставки
     * @request GET:/api/conf-doc/v1/external/signsupply
     * @secure
     */
    getAllSignSupplyList: (params: RequestParams = {}) =>
      this.request<SignSupplyResponse[], ErrorMessage>({
        path: `/api/conf-doc/v1/external/signsupply`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение прав пользователя на операции с документами
     * @name GetClientPermissions
     * @summary Получение прав пользователя на операции с документами
     * @request GET:/api/conf-doc/v1/external/permissions/{documentType}
     * @secure
     */
    getClientPermissions: (documentType: string, params: RequestParams = {}) =>
      this.request<PermissionResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/permissions/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о декларациях товара
     * @name GetDeclarations
     * @summary Получение деклараций клиента
     * @request GET:/api/conf-doc/v1/external/decl
     * @secure
     */
    getDeclarations: (
      query: {
        size: number;
        position: number;
        dtAmount?: number;
        unk?: string;
        dtNumber?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetAllDeclarationsResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/decl`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о декларациях товара
     * @name GetDeclaration
     * @summary Получение декларации клиента по идентификатору и айди клиента
     * @request GET:/api/conf-doc/v1/external/decl/{dtId}
     * @secure
     */
    getDeclaration: (dtId: string, params: RequestParams = {}) =>
      this.request<GetDeclarationByIdResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/decl/${dtId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetAllCurrencyList
     * @summary Получение списка валют
     * @request GET:/api/conf-doc/v1/external/currency
     * @secure
     */
    getAllCurrencyList: (params: RequestParams = {}) =>
      this.request<CurrencyResponse[], ErrorMessage>({
        path: `/api/conf-doc/v1/external/currency`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetAllCountryList
     * @summary Получение списка стран
     * @request GET:/api/conf-doc/v1/external/country
     * @secure
     */
    getAllCountryList: (params: RequestParams = {}) =>
      this.request<CountryResponse[], ErrorMessage>({
        path: `/api/conf-doc/v1/external/country`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные подписания
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/conf-doc/v1/external/confirmation/order-ccb
     * @secure
     */
    getOrderCcb: (query: { documentId: string }, params: RequestParams = {}) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные подписания
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/conf-doc/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetAllCodeTypeDocList
     * @summary Получение списка кодов вида подтверждающих документов
     * @request GET:/api/conf-doc/v1/external/codetypedoc
     * @secure
     */
    getAllCodeTypeDocList: (params: RequestParams = {}) =>
      this.request<CodeTypeDocResponse[], ErrorMessage>({
        path: `/api/conf-doc/v1/external/codetypedoc`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/conf-doc/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/conf-doc/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
